module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-900.2ad492e7.woff2";